import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "brand-app-bg q-pb-xs overflow-hidden"
}
const _hoisted_2 = { class: "flex justify-between full-width" }
const _hoisted_3 = {
  class: "brand-bg-dark text-white text-subtitle1",
  style: {"padding":"12px 16px 12px 16px","border-radius":"10px"}
}
const _hoisted_4 = { class: "text-subtitle1" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "text-h5" }
const _hoisted_7 = { class: "text-subtitle1" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "text-subtitle1" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-subtitle1" }
const _hoisted_12 = { class: "text-subtitle3" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "text-subtitle1" }
const _hoisted_16 = { class: "text-subtitle3" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "text-subtitle1" }
const _hoisted_20 = { class: "text-subtitle3" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "text-subtitle1" }
const _hoisted_24 = { class: "text-subtitle3" }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "row justify-end no-wrap" }
const _hoisted_27 = {
  key: 0,
  class: "bg-white full-width full-height"
}
const _hoisted_28 = {
  key: 1,
  class: "bg-white full-width full-height"
}
const _hoisted_29 = {
  key: 0,
  class: "q-mt-md"
}
const _hoisted_30 = { class: "text-subtitle1" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "text-h5" }
const _hoisted_33 = { class: "text-subtitle1" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "text-subtitle1" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "text-subtitle1" }
const _hoisted_38 = { class: "text-subtitle3" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "text-subtitle1" }
const _hoisted_42 = { class: "text-subtitle3" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { class: "text-subtitle1" }
const _hoisted_46 = { class: "text-subtitle3" }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "row justify-end no-wrap" }
const _hoisted_49 = {
  key: 0,
  class: "bg-white full-width full-height"
}
const _hoisted_50 = {
  key: 1,
  class: "bg-white full-width full-height"
}
const _hoisted_51 = { key: 1 }
const _hoisted_52 = {
  key: 0,
  class: "brand-app-bg"
}
const _hoisted_53 = { class: "bg-dark q-pa-md text-subtitle1 text-white" }
const _hoisted_54 = {
  key: 0,
  class: "bg-white full-width full-height"
}
const _hoisted_55 = {
  key: 1,
  class: "bg-white full-width full-height"
}
const _hoisted_56 = {
  key: 2,
  class: "bg-white full-width full-height"
}
const _hoisted_57 = {
  key: 0,
  class: "brand-app-bg"
}
const _hoisted_58 = { class: "bg-dark q-pa-md text-subtitle1 text-white" }
const _hoisted_59 = {
  key: 0,
  class: "bg-white full-width full-height"
}
const _hoisted_60 = {
  key: 1,
  class: "bg-white full-width full-height"
}
const _hoisted_61 = {
  key: 2,
  class: "bg-white full-width full-height"
}
const _hoisted_62 = { class: "flex full-width justify-end q-pa-md" }

import { PropType, ref, computed, watch } from "vue"
  import { useRouter } from "vue-router";
  import { Dialog, QTableColumn } from "quasar";

  import { useAuthStore } from "src/stores/auth-store";
  import { ProposalService } from "src/services";
  import { useProposalStore } from "src/stores/proposal-store";
  import { useSettingsStore } from "src/stores/settings-store";

  import { useHideLoading, useLoading, useCapitalise, useCurrencyFormatter, usePriceForTerm } from "src/functions";

  import StockDetails from "src/components/stock/StockDetails.vue";
  import LenderDecisions from "src/components/customer/quote/LenderDecisions.vue";
  import QuoteCard from "./QuoteCard.vue";

  import TableRow from "src/types/shared/table-row";
  import { AvailableProposal, Vehicle, LoanApplication, HpPrice, PcpPrice, LenderQuote } from "src/types/loan-application/index"
  import { ContactType_Enum, ProductType_Enum, Title_Enum } from "src/types/enums/index";
  import { QuoteProceed } from "src/types/quote/index";
  import { StockFilter } from "src/types/vehicle-search/index";

  import { FinanceCompanies } from "src/const/finance-companies";
  import { allPcpLenders, pcpLendersIntegrated } from "src/const/pcp-lenders"; 
  import StockDetailsForm from "src/components/form/forms/stock-details-form";

  import QuoteSend from "src/components/customer/quote/QuoteSend.vue";
  import { QuoteAcceptRequest } from "src/types/quote/quote-accept";
  import { useMapChannelsToFlags } from "src/functions/mappers/use-map-channels-to-flags";
  import { MessageRequest } from "src/types/notification/message-request";
  import { useWebSocketStore } from "src/stores/websocket-store";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'QuoteViewer',
  props: {
    application: {
      type: Object as PropType<LoanApplication>,
      default: null
    },
    vehicle: {
      type: Object as PropType<Vehicle>,
      default: {}
    },
    proposals: {
      type: Array as PropType<AvailableProposal[]>,
      default: []
    },
    partEx: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    initialTerm: {
      type: Number,
      default: 60
    },
  },
  setup(__props) {

  const authStore = useAuthStore();
  const proposalStore = useProposalStore();
  const settingsStore = useSettingsStore();
  const wsStore = useWebSocketStore();
  const router = useRouter();

  const isMobile = computed(() => settingsStore.isMobile);

  const props = __props

  const tab = ref('hp');

  const cols = computed(() => {
    let c = [
      { name: 'term', label: 'Term', field: 'term', align: 'left' }
    ] as QTableColumn[]

    c.push({ name: 'lender', label: 'Lender', field: 'lender', align: 'left', headerStyle: "min-width: 115px", style: "min-width: 115px" });

    c.push(
      { name: 'ppm', label: 'Per Month', field: 'ppm', sortable: true, align: 'left' },
      { name: 'apr', label: 'APR', field: 'apr', align: 'left' },
      { name: 'deposit', label: 'Deposit', field: 'deposit', sortable: true, align: 'left' },
      { name: 'px', label: 'Part Ex.', field: 'px', sortable: true, align: 'left' },
      { name: 'totalPayable', label: 'Total Payable', field: 'totalPayable', sortable: true, align: 'left' },
      { name: 'residual', label: 'Residual', field: 'residual', sortable: true, align: 'left' }
    )

    return c;
  })

  const hpCols = computed(() => {
    let c = [ 'term' ];

      c.push('lender');


    c.push('ppm', 'apr', 'deposit', 'px', 'totalPayable');

    return c;
  })
  
  const termsToShow = computed(() => settingsStore.termsToShow);

  const pcpTerm = ref(termsToShow.value.includes(props.initialTerm) ? props.initialTerm : 60);

  const filters = computed(() => {
    return {
      term: props.initialTerm,
      annualMileage: props.application.vehicle && props.application.vehicle.annualMileage ? props.application.vehicle.annualMileage : useProposalStore().defaultPcpMileage
    } as StockFilter
  })

  const selectedQuote = ref<HpPrice | PcpPrice | null>(null);
  const selectedProduct = ref('hp');
  const viewDetails = ref(false);
  const selectedHP = ref<HpPrice | null>(null);
  const selectedPCP = ref<PcpPrice | null>(null);

  function viewQuote(row: TableRow, pcp = false) {
    console.log(row);
    filters.value.term = row.term;
    selectedProduct.value = pcp ? 'pcp' : 'hp';
    selectedQuote.value = row.matrix;
    if(pcp){
      selectedPCP.value = row.matrix;
      selectedHP.value = hpRows.value.find(hp => hp.term === row.term)?.matrix as HpPrice;
      
    } else {
      selectedHP.value = row.matrix as HpPrice;
      selectedPCP.value = pcpRows.value.find(pcp => pcp.term === row.term)?.matrix as PcpPrice;
    }
    
    viewDetails.value = true;
  }

  function proceed(row: TableRow, event?: Event) {
    selectedQuote.value = row.matrix;

    event ? event.stopPropagation() : null;

    Dialog.create({
      title: "Proceed",
      message: `Proceed with ${props.application.customer ? (useCapitalise(props.application.customer.firstName) + " " + useCapitalise(props.application.customer.lastName)) : 'quote'} for ${selectedQuote.value.term} month ${selectedQuote.value.isPCP ? 'PCP' : 'HP'} @ ${useCurrencyFormatter(selectedQuote.value.monthlyPayment)} per month?`
    }).onOk(() => {
      proceedWithQuote("proceed")
    })
  }

  const showSend = ref(false);

  function beginSend(row: HpPrice | PcpPrice) {
    showSend.value = true;
    selectedQuote.value = row;
  }

  async function proceedWithQuote(type: string) {
    useLoading("One moment...")
    if (!selectedQuote.value) {
      return;
    }

    const channels = [ContactType_Enum.Email] as ContactType_Enum[];

    const q = {
      affiliateUserId: Number(props.application.affiliateUserId),
      referenceId: props.application.brokerReference,
      fullName: props.application.customer ? Title_Enum[props.application.customer.title] + " " + props.application.customer.firstName + " " + props.application.customer.lastName : 'No customer provided',
      dealer: authStore.user.dealerName,
      vehicleId: props.application.vehicle.vehicleId,
      vrm: props.application.vehicle.vehicleRegistration,
      make: props.application.vehicle.make,
      model: props.application.vehicle.model,
      mileage: props.application.vehicle.mileage,
      fuelType: props.application.vehicle.fuel,
      transmission: props.application.vehicle.transmission,
      registrationDate: props.application.vehicle.registrationDate,
      price: props.application.vehicle.price,
      deposit: props.application.deposit,
      pxValue: props.application.pxValue,
      pxSettlement: props.application.settlement,
      btf: selectedQuote.value.amountToFinance,
      lender: selectedQuote.value.financeCompany,
      term: selectedQuote.value.term,
      apr: selectedQuote.value.effectiveRate ?? selectedQuote.value.apr,
      monthlyPayment: selectedQuote.value.monthlyPayment,
      optionToPurchase: selectedQuote.value.lendersPostFees,
      costOfCredit: selectedQuote.value.costOfCredit,
      optionalFinalPayment: selectedQuote.value.finalPayment,
      amountPayable: selectedQuote.value.totalAmountPayable,
      productType: selectedQuote.value.isPCP ? 1 : 0,
      annualMileage: props.application.vehicle.annualMileage
    } as QuoteAcceptRequest;

    const channel = useMapChannelsToFlags(channels);

    const message: MessageRequest = {
        scenario: 'DealerIntro_Quote',
        data: {
            ...q,
            channel,
        }
    };

    await wsStore.sendScenarioMessage(message, props.application.affiliateUserId).catch(err => {
        throw new Error(err.message);
    });

    useHideLoading();

    Dialog.create({
      title: "Request Submitted",
      message: `Your request to ${type} with this quote has been sent to our team. Someone will be in touch as soon as possible.`
    })
      
  }

  const stockDetailsRef = ref<StockDetailsForm | null>(null);

  function convertToProposal(row?: TableRow) {

    if (row) {
      props.application.lenderQuote = {
        lender: row.matrix.financeCompany,
        quoteProductType: row.matrix.isPCP ? ProductType_Enum.PCP : ProductType_Enum.HP,
        apr: row.matrix.effectiveRate,
        optionalFinalPayment: parseFloat(row.matrix.finalPayment.toFixed(2)),
        optionToPurchaseFee: parseFloat(row.matrix.lendersPostFees.toFixed(2)),
        totalCostOfCredit: parseFloat(row.matrix.costOfCredit.toFixed(2)),
        annualMileageLimit: props.application.vehicle.annualMileage ? parseFloat(props.application.vehicle.annualMileage.toFixed(2)) : proposalStore.defaultPcpMileage,
        excessMileageCharge: parseFloat((0.08).toFixed(2)),
        totalRepayable: parseFloat(row.matrix.totalAmountPayable.toFixed(2)),
        monthlyPayment: parseFloat(row.matrix.monthlyPayment.toFixed(2)),
      } as LenderQuote;
      props.application.term = row?.term ?? filters.value.term;
    }
    else {
      const selectedQuote = stockDetailsRef.value?.getSelectedQuote();
      if (selectedQuote == null) return;
      props.application.lenderQuote = {
        lender: selectedQuote.financeCompany,
        quoteProductType: selectedQuote.isPCP ? ProductType_Enum.PCP : ProductType_Enum.HP,
        apr: selectedQuote.effectiveRate,
        optionalFinalPayment: parseFloat(selectedQuote.finalPayment.toFixed(2)),
        optionToPurchaseFee: parseFloat(selectedQuote.lendersPostFees.toFixed(2)),
        totalCostOfCredit: parseFloat(selectedQuote.costOfCredit.toFixed(2)),
        annualMileageLimit: props.application.vehicle.annualMileage ? parseFloat(props.application.vehicle.annualMileage.toFixed(2)) : proposalStore.defaultPcpMileage,
        excessMileageCharge: parseFloat((0.08).toFixed(2)),
        totalRepayable: parseFloat(selectedQuote.totalAmountPayable.toFixed(2)),
        monthlyPayment: parseFloat(selectedQuote.monthlyPayment.toFixed(2))
      } as LenderQuote;
    }
    proposalStore.convert(props.application!);
    router.push({ name: 'NewProposal' })
  }

  const pcpRows = computed(() => {
    if (!props.vehicle) {
      return []
    }

    const rs = [] as TableRow[]

    let t = props.vehicle.pcpMatrix ? 
      props.vehicle.pcpMatrix.filter(m => m.financeCompanyId !== 49)
        .find(t => t.term === pcpTerm.value) 
      : null

    if(!t){
      return rs;
    }

    let isPrime = props.application.proposals.find(p => p.financeCompanyId === t.financeCompanyId)!.isPrime ? true : false;
    rs.push(
      {
        term: t.term,
        lender: t.financeCompanyId,
        ppm: t.monthlyPayment,
        apr: t.effectiveRate,
        deposit: t.depositDisplay,
        px: t.pxValue - t.pxSettlement,
        totalPayable: t.totalAmountPayable,
        residual: t.finalPayment,
        pcp: true,
        prime: isPrime,
        matrix: t,
        isQuickQuote: props.application.isQuickQuote,
        state: props.application.state,
        showCaveat: [67,73].includes(t.financeCompanyId) ? true : false
      }
    )

    t.altOptions?.filter(m => m.financeCompanyId !== 49).forEach(m => {
      if (!rs.find(r => r.lender === m.financeCompanyId)) {
        isPrime = props.application.proposals.find(p => p.financeCompanyId === m.financeCompanyId)!.isPrime ? true : false;
        rs.push({
          term: m.term,
          lender: m.financeCompanyId,
          ppm: m.monthlyPayment,
          apr: m.effectiveRate,
          deposit: m.depositDisplay,
          px: m.pxValue - m.pxSettlement,
          totalPayable: m.totalAmountPayable,
          residual: m.finalPayment,
          pcp: true,
          prime: isPrime,
          matrix: m,
          isQuickQuote: props.application.isQuickQuote,
          state: props.application.state,
          showCaveat: [67,73].includes(m.financeCompanyId) ? true : false
        })
      }

    })

    t.otherOptions?.filter(m => m.financeCompanyId !== 49).forEach(m => {
      if (!rs.find(r => r.lender === m.financeCompanyId)) {
        isPrime = props.application.proposals.find(p => p.financeCompanyId === m.financeCompanyId)!.isPrime ? true : false;
        rs.push({
          term: m.term,
          lender: m.financeCompanyId,
          ppm: m.monthlyPayment,
          apr: m.effectiveRate,
          deposit: m.depositDisplay,
          px: m.pxValue - m.pxSettlement,
          totalPayable: m.totalAmountPayable,
          residual: m.finalPayment,
          pcp: true,
          prime: isPrime,
          matrix: m,
          isQuickQuote: props.application.isQuickQuote,
          state: props.application.state,
          showCaveat: [67,73].includes(m.financeCompanyId) ? true : false
        })
      }
    })  

    return rs;
  })

  const hpRows = computed(() => {
    if (!props.vehicle || !props.vehicle.priceMatrix || props.vehicle.priceMatrix.length === 0) {
      return []
    }

    let hasBespokeRate = false;
    if(props.application.isQuickQuote && proposalStore.bespokeRates){
      const bestBespokeRate = proposalStore.bespokeRates.reduce((prev, current) => (prev.rate < current.rate) ? prev : current);
      hasBespokeRate = true;
      const ps = [] as HpPrice[];

      for(let term of [24, 36, 48, 60]){
        let t = props.vehicle.priceMatrix.find(m => m.term === term && m.financeCompanyId === bestBespokeRate.financeCompanyId);
        if(t){
            ps.push(t);
        }
        else{
          t = props.vehicle.priceMatrix.find(m => m.term === term);
          if(t){
            let alt = t.altOptions.find(a => a.financeCompanyId === bestBespokeRate.financeCompanyId && a.term === t?.term) as HpPrice;
            if(alt){
              ps.push(alt);
            }
            else{
              let other = t.otherOptions.find(a => a.financeCompanyId === bestBespokeRate.financeCompanyId && a.term === t?.term) as HpPrice;
              if(other){
                ps.push(other);
              }
              else{
                ps.push(t);
              }
            }
          }
        }
      }

      return ps.map(m => {
        let prime = props.application.proposals.find(p => p.financeCompanyId === m.financeCompanyId)!.isPrime ? true : false;
                
        return {
          term: m.term,
          lender: m.financeCompanyId,
          ppm: m.monthlyPayment,
          apr: m.effectiveRate,
          deposit: m.depositDisplay,
          px: m.pxValue - m.pxSettlement,
          totalPayable: m.totalAmountPayable,
          residual: m.finalPayment,
          pcp: false,
          prime,
          matrix: m,
          isQuickQuote: props.application.isQuickQuote,
          state: props.application.state
        }
      })
    }

    return props.vehicle.priceMatrix.
      filter(m => [24, 36, 48, 60].includes(m.term)).
      sort((a, b) => a.term < b.term ? 1 : -1).
      map(m => {
        let prime = props.application.proposals.find(p => p.financeCompanyId === m.financeCompanyId)!.isPrime ? true : false;
        
        if(props.application.isQuickQuote && !hasBespokeRate){
          m.financeCompany = 'Car Finance 247';
          //m.financeCompanyId = 49;
        }
        
        return {
          term: m.term,
          lender: props.application.isQuickQuote ? 49 : m.financeCompanyId,
          ppm: m.monthlyPayment,
          apr: m.effectiveRate,
          deposit: m.depositDisplay,
          px: m.pxValue - m.pxSettlement,
          totalPayable: m.totalAmountPayable,
          residual: m.finalPayment,
          pcp: false,
          prime,
          matrix: m,
          isQuickQuote: props.application.isQuickQuote,
          state: props.application.state
        }
      })
  })

  function logo(id: number) {
    const l = FinanceCompanies.find(f => f.financeCompanyId === id);
    if (!l) {
      return "";
    }
    return require(`assets/logos/${l.logo}`)
  }

  watch(() => props.application.state, () => {
    console.log("ns", props.application.state)
  })

  const isProcessing = computed(() => {
    if (!props.proposals || (props.proposals && props.proposals.find(p => p.loanProposalStatus && (p.loanProposalStatus.toString() === "Accepted" || p.loanProposalStatus.toString() === "ProvisionalAcceptance")))) {
      return false;
    }
    if (props.proposals.find(p => p.loanProposalStatus && p.loanProposalStatus.toString() === "Processing")) {
      return true;
    }
    return false;
  })

  function showUnderwriting() {
    Dialog.create({
      title: "Underwriting",
      message: "This application is with our underwriting team, we will have updates shortly"
    })
  }

  const customerFailedHP = computed(() => {
    return props.proposals.filter(p =>
      p.loanProposalStatus &&
        (p.loanProposalStatus === 'Accepted' ||
          ((p.loanProposalStatus === "ConditionallyAccepted" || p.loanProposalStatus === "ProvisionalAcceptance") && (!p.customerRuleResults || !p.customerRuleResults.find(r => r.resultType === "FixedDecline"))))).length > 0 ? false : true
        }
  )

  const vehicleFailedHP = computed(() => props.vehicle.cannotPrice ? true : false)

  const customerFailedPCP = computed(() => {
    return customerFailedHP.value || 
      props.proposals.filter(p => 
        (
          p.loanProposalStatus && (p.loanProposalStatus === "Accepted" || p.loanProposalStatus === "ConditionallyAccepted" || p.loanProposalStatus === "ProvisionalAcceptance")
        ) 
          && 
        (
          !p.customerRuleResults || (!p.customerRuleResults.find(r => r.resultType === "FixedDecline" && p.loanProposalStatus !== "Accepted")) 
        ) 
        &&
        pcpLendersIntegrated.includes(p.financeCompanyId!)
      ).length > 0 ? false : true}
  )

  const hasPcpLenders = computed(() => {
      return props.proposals.filter(p => 
        (
          p.loanProposalStatus && (p.loanProposalStatus === "Accepted" || p.loanProposalStatus === "ConditionallyAccepted" || p.loanProposalStatus === "ProvisionalAcceptance")
        ) 
          && 
        (
          !p.customerRuleResults || (!p.customerRuleResults.find(r => r.resultType === "FixedDecline" && p.loanProposalStatus !== "Accepted")) 
        ) 
        &&
        allPcpLenders.includes(p.financeCompanyId!)
      ).length > 0 ? true : false}
  )
  
  const vehicleFailedPCP = computed(() => props.vehicle.cannotPrice || props.vehicle.cannotPricePCP || props.vehicle.mileage === null || props.vehicle.mileage === undefined ? true : false)

  const maxTermPcp = computed(() => usePriceForTerm(props.vehicle, props.vehicle.pcpMatrix, pcpTerm.value, true))

return (_ctx: any,_cache: any) => {
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_DialogContainer = _resolveComponent("DialogContainer")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!isMobile.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_q_table, {
            flat: "",
            bordered: "",
            rows: pcpRows.value,
            columns: cols.value,
            "row-key": "name",
            "hide-pagination": "",
            "hide-bottom": __props.loading ? true : customerFailedPCP.value ? false : __props.loading ,
            pagination: { rowsPerPage: 0 },
            "table-header-class": "brand-app-bg",
            class: "sticky-table-dark dense-top dense-bottom not-dark-bottom",
            loading: __props.loading ? true : customerFailedPCP.value ? false : __props.loading
          }, {
            loading: _withCtx(() => [
              _createVNode(_component_q_inner_loading, {
                showing: "",
                color: "primary",
                label: pcpRows.value.length > 0 ? 'Updating Quotes...' : undefined,
                "label-class": "text-grey-7 q-pt-md"
              }, null, 8, ["label"])
            ]),
            top: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(customerFailedHP.value ? 'Customer has not been approved' : 'PCP'), 1),
                ((!__props.loading || pcpRows.value.length > 0) && (!customerFailedHP.value) && (!customerFailedPCP.value && !vehicleFailedPCP.value))
                  ? (_openBlock(), _createBlock(_component_q_tabs, {
                      key: 0,
                      modelValue: pcpTerm.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pcpTerm).value = $event)),
                      indicator: "",
                      "indicator-color": "white",
                      dense: "",
                      class: "text-subtitle3 text-grey-5 q-mr-md",
                      "active-class": "text-white"
                    }, {
                      default: _withCtx(() => [
                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "tect-subtitle3 text-uppercase" }, " Term: ", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(termsToShow.value, (term) => {
                          return (_openBlock(), _createBlock(_component_q_tab, {
                            key: 'tb'+term,
                            name: term,
                            style: {"width":"46px"},
                            dense: "",
                            label: term
                          }, null, 8, ["name", "label"]))
                        }), 128))
                      ]),
                      _: 1,
                      __: [16]
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            header: _withCtx((props) => [
              ((!__props.loading || pcpRows.value.length > 0) && !customerFailedPCP.value && !vehicleFailedPCP.value)
                ? (_openBlock(), _createBlock(_component_q_tr, {
                    key: 0,
                    props: props,
                    class: "brand-app-bg"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                        return (_openBlock(), _createBlock(_component_q_th, {
                          key: col.name,
                          props: props,
                          class: "text-caption text-weight-bold text-uppercase",
                          style: {"font-weight":"700 !important","font-size":"10px !important"},
                          "auto-width": ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(col.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]))
                      }), 128)),
                      _createVNode(_component_q_th)
                    ]),
                    _: 2
                  }, 1032, ["props"]))
                : _createCommentVNode("", true)
            ]),
            body: _withCtx((props) => [
              _createVNode(_component_q_tr, {
                props: props,
                onClick: ($event: any) => (viewQuote(props.row, true)),
                class: "cursor-pointer",
                style: {"height":"55px!important"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_td, {
                    key: "term",
                    props: props
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(props.row.term), 1),
                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-subtitle3" }, " mo", -1))
                    ]),
                    _: 2,
                    __: [17]
                  }, 1032, ["props"]),
                  _createVNode(_component_q_td, {
                    key: "lender",
                    props: props,
                    class: "test-subtitle1",
                    style: {"padding-top":"0px !important","padding-bottom":"0px !important"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_img, {
                        src: logo(props.row.lender),
                        fit: "contain",
                        class: "q-px-sm",
                        height: "100%",
                        style: {}
                      }, null, 8, ["src"])
                    ]),
                    _: 2
                  }, 1032, ["props"]),
                  _createVNode(_component_q_td, {
                    key: "ppm",
                    props: props,
                    class: _normalizeClass(props.cols[2 - (__props.application.isQuickQuote ? 1 : 0)]['__thClass'].includes('sorted') ? 'brand-bg-highlight' : '')
                  }, {
                    default: _withCtx(() => [
                      (props.row.ppm)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(useCurrencyFormatter)(props.row.ppm, 2, 2).split('.')[0]), 1),
                            _createElementVNode("span", _hoisted_7, "." + _toDisplayString(_unref(useCurrencyFormatter)(props.row.ppm, 2, 2).split('.')[1]) + _toDisplayString(props.row.showCaveat === true ? '*' : ''), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(_component_q_icon, { name: "mdi-minus" })
                          ]))
                    ]),
                    _: 2
                  }, 1032, ["props", "class"]),
                  _createVNode(_component_q_td, {
                    key: "apr",
                    props: props
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(props.row.apr) + "%", 1)
                    ]),
                    _: 2
                  }, 1032, ["props"]),
                  _createVNode(_component_q_td, {
                    key: "deposit",
                    props: props,
                    class: _normalizeClass(props.cols[4 - (__props.application.isQuickQuote ? 1 : 0)]['__thClass'].includes('sorted') ? 'brand-bg-highlight' : '')
                  }, {
                    default: _withCtx(() => [
                      (props.row.deposit)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(useCurrencyFormatter)(props.row.deposit, 2, 2).split('.')[0]), 1),
                              _createElementVNode("span", _hoisted_12, "." + _toDisplayString(_unref(useCurrencyFormatter)(props.row.deposit, 2, 2).split('.')[1]), 1)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode(_component_q_icon, { name: "mdi-minus" })
                          ]))
                    ]),
                    _: 2
                  }, 1032, ["props", "class"]),
                  _createVNode(_component_q_td, {
                    key: "px",
                    props: props,
                    class: _normalizeClass(props.cols[5 - (__props.application.isQuickQuote ? 1 : 0)]['__thClass'].includes('sorted') ? 'brand-bg-highlight' : '')
                  }, {
                    default: _withCtx(() => [
                      (props.row.px)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(useCurrencyFormatter)(props.row.px, 2, 2).split('.')[0]), 1),
                            _createElementVNode("span", _hoisted_16, "." + _toDisplayString(_unref(useCurrencyFormatter)(props.row.px, 2, 2).split('.')[1]), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_q_icon, { name: "mdi-minus" })
                          ]))
                    ]),
                    _: 2
                  }, 1032, ["props", "class"]),
                  _createVNode(_component_q_td, {
                    key: "totalPayable",
                    props: props,
                    class: _normalizeClass(props.cols[6 - (__props.application.isQuickQuote ? 1 : 0)]['__thClass'].includes('sorted') ? 'brand-bg-highlight' : '')
                  }, {
                    default: _withCtx(() => [
                      (props.row.totalPayable)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(useCurrencyFormatter)(props.row.totalPayable, 2, 2).split('.')[0]), 1),
                            _createElementVNode("span", _hoisted_20, "." + _toDisplayString(_unref(useCurrencyFormatter)(props.row.totalPayable, 2, 2).split('.')[1]), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createVNode(_component_q_icon, { name: "mdi-minus" })
                          ]))
                    ]),
                    _: 2
                  }, 1032, ["props", "class"]),
                  _createVNode(_component_q_td, {
                    key: "residual",
                    props: props,
                    class: _normalizeClass(props.cols[7 - (__props.application.isQuickQuote ? 1 : 0)]['__thClass'].includes('sorted') ? 'brand-bg-highlight' : '')
                  }, {
                    default: _withCtx(() => [
                      (props.row.residual)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(useCurrencyFormatter)(props.row.residual, 2, 2).split('.')[0]), 1),
                            _createElementVNode("span", _hoisted_24, "." + _toDisplayString(_unref(useCurrencyFormatter)(props.row.residual, 2, 2).split('.')[1]), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createVNode(_component_q_icon, { name: "mdi-minus" })
                          ]))
                    ]),
                    _: 2
                  }, 1032, ["props", "class"]),
                  _createVNode(_component_q_td, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_26, [
                        (__props.application.isQuickQuote)
                          ? (_openBlock(), _createBlock(_component_q_btn, {
                              key: 0,
                              class: "brand-button",
                              label: "Convert",
                              color: "primary",
                              outline: "",
                              onClick: _withModifiers(($event: any) => (convertToProposal(props.row)), ["prevent","stop"])
                            }, null, 8, ["onClick"]))
                          : (__props.application.state === 0 && props.row.prime)
                            ? (_openBlock(), _createBlock(_component_q_btn, {
                                key: 1,
                                class: "brand-button",
                                label: "Underwriting",
                                color: "primary",
                                outline: "",
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showUnderwriting()), ["prevent","stop"]))
                              }))
                            : (_openBlock(), _createBlock(_component_q_btn, {
                                key: 2,
                                class: "brand-button",
                                label: "Proceed",
                                color: "primary",
                                outline: "",
                                onClick: _withModifiers(($event: any) => (proceed(props.row, $event)), ["prevent","stop"])
                              }, null, 8, ["onClick"])),
                        _createVNode(_component_q_btn, {
                          round: "",
                          flat: "",
                          class: "q-ml-sm",
                          icon: "mdi-dots-vertical",
                          size: "sm",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent","stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_menu, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_card, { bordered: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_list, { separator: "" }, {
                                      default: _withCtx(() => [
                                        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                          clickable: "",
                                          class: "flex items-center",
                                          onClick: ($event: any) => (viewQuote(props.row))
                                        }, {
                                          default: _withCtx(() => _cache[18] || (_cache[18] = [
                                            _createTextVNode("View quote details")
                                          ])),
                                          _: 2,
                                          __: [18]
                                        }, 1032, ["onClick"])), [
                                          [_directive_close_popup]
                                        ]),
                                        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                          clickable: "",
                                          class: "flex items-center",
                                          onClick: ($event: any) => (beginSend(props.row.matrix))
                                        }, {
                                          default: _withCtx(() => _cache[19] || (_cache[19] = [
                                            _createTextVNode("Send to customer...")
                                          ])),
                                          _: 2,
                                          __: [19]
                                        }, 1032, ["onClick"])), [
                                          [_directive_close_popup]
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_q_menu, { "context-menu": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card, { bordered: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_list, { separator: "" }, {
                            default: _withCtx(() => [
                              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                clickable: "",
                                class: "flex items-center",
                                onClick: ($event: any) => (viewQuote(props.row))
                              }, {
                                default: _withCtx(() => _cache[20] || (_cache[20] = [
                                  _createTextVNode("View quote details")
                                ])),
                                _: 2,
                                __: [20]
                              }, 1032, ["onClick"])), [
                                [_directive_close_popup]
                              ]),
                              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                clickable: "",
                                class: "flex items-center",
                                onClick: ($event: any) => (beginSend(props.row.matrix))
                              }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createTextVNode("Send to customer...")
                                ])),
                                _: 2,
                                __: [21]
                              }, 1032, ["onClick"])), [
                                [_directive_close_popup]
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["props", "onClick"])
            ]),
            "no-data": _withCtx(({ icon, message }) => [
              (!isProcessing.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(_component_q_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { side: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_avatar, {
                              color: "negative",
                              size: "20px"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_icon, {
                                  name: customerFailedHP.value ? 'mdi-close-thick' : 'mdi-exclamation-thick',
                                  color: "white",
                                  style: {"font-size":"16px","font-weight":"bold"}
                                }, null, 8, ["name"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, { class: "text-subtitle2" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(customerFailedHP.value ? 'Unfortunately, we’ve not been able to obtain an approval with any of our lenders.' : customerFailedPCP.value ? hasPcpLenders.value ? `Customer may qualify for PCP, for more info please contact us on ${_unref(settingsStore).pcpContactNumber}` :'Customer not approved for PCP' : vehicleFailedPCP.value ? ('This vehicle does not meet the criteria for PCP - ' + (__props.vehicle.cannotPriceReasonPCP ?? 'Failed rule')) : maxTermPcp.value ? maxTermPcp.value.subtext : ''), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createVNode(_component_q_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { side: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_spinner, {
                              color: "primary",
                              size: "xs"
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_q_item_section, { class: "text-subtitle2" }, {
                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createTextVNode("We are still awaiting a decision")
                          ])),
                          _: 1,
                          __: [22]
                        })
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          }, 8, ["rows", "columns", "hide-bottom", "loading"]),
          (!customerFailedHP.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createVNode(_component_q_table, {
                  flat: "",
                  bordered: "",
                  rows: hpRows.value,
                  columns: cols.value,
                  "row-key": "name",
                  "hide-pagination": "",
                  "hide-bottom": isProcessing.value ? false : !customerFailedHP.value && !__props.loading ? false : true,
                  "visible-columns": hpCols.value,
                  pagination: { rowsPerPage: 0 },
                  "table-header-class": "brand-app-bg",
                  class: _normalizeClass(["sticky-table-dark dense-bottom", isProcessing.value ? 'not-dark-bottom' : '']),
                  loading: __props.loading
                }, {
                  loading: _withCtx(() => [
                    _createVNode(_component_q_inner_loading, {
                      showing: "",
                      color: "primary",
                      label: hpRows.value.length > 0 ? 'Updating Quotes...' : undefined,
                      "label-class": "text-grey-7 q-pt-md"
                    }, null, 8, ["label"])
                  ]),
                  top: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createElementVNode("div", { class: "brand-bg-dark text-white text-subtitle1" }, "HP", -1)
                  ])),
                  header: _withCtx((props) => [
                    ((!__props.loading || hpRows.value.length > 0) && !customerFailedHP.value && !vehicleFailedHP.value)
                      ? (_openBlock(), _createBlock(_component_q_tr, {
                          key: 0,
                          props: props,
                          class: "brand-app-bg"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                              return (_openBlock(), _createBlock(_component_q_th, {
                                key: col.name,
                                props: props,
                                class: "text-caption text-weight-bold text-uppercase",
                                style: {"font-weight":"700 !important","font-size":"10px !important"},
                                "auto-width": ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(col.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["props"]))
                            }), 128)),
                            _createVNode(_component_q_th)
                          ]),
                          _: 2
                        }, 1032, ["props"]))
                      : _createCommentVNode("", true)
                  ]),
                  body: _withCtx((props) => [
                    _createVNode(_component_q_tr, {
                      props: props,
                      onClick: ($event: any) => (viewQuote(props.row)),
                      class: "cursor-pointer",
                      style: {"height":"55px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_td, {
                          key: "term",
                          props: props
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_30, _toDisplayString(props.row.term), 1),
                            _cache[24] || (_cache[24] = _createElementVNode("span", { class: "text-subtitle3" }, " mo", -1))
                          ]),
                          _: 2,
                          __: [24]
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "lender",
                          props: props,
                          class: "test-subtitle1",
                          style: {"padding-top":"0px !important","padding-bottom":"0px !important"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_img, {
                              src: logo(props.row.lender),
                              fit: "contain",
                              class: "q-px-sm",
                              height: "100%",
                              style: {}
                            }, null, 8, ["src"])
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "ppm",
                          props: props,
                          class: _normalizeClass(props.cols[2 - (__props.application.isQuickQuote ? 1 : 0)]['__thClass'].includes('sorted') ? 'brand-bg-highlight' : '')
                        }, {
                          default: _withCtx(() => [
                            (props.row.ppm)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(useCurrencyFormatter)(props.row.ppm, 2, 2).split('.')[0]), 1),
                                  _createElementVNode("span", _hoisted_33, "." + _toDisplayString(_unref(useCurrencyFormatter)(props.row.ppm, 2, 2).split('.')[1]), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                  _createVNode(_component_q_icon, { name: "mdi-minus" })
                                ]))
                          ]),
                          _: 2
                        }, 1032, ["props", "class"]),
                        _createVNode(_component_q_td, {
                          key: "apr",
                          props: props
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_35, _toDisplayString(props.row.apr) + "%", 1)
                          ]),
                          _: 2
                        }, 1032, ["props"]),
                        _createVNode(_component_q_td, {
                          key: "deposit",
                          props: props,
                          class: _normalizeClass(props.cols[4 - (__props.application.isQuickQuote ? 1 : 0)]['__thClass'].includes('sorted') ? 'brand-bg-highlight' : '')
                        }, {
                          default: _withCtx(() => [
                            (props.row.deposit)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                  _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(useCurrencyFormatter)(props.row.deposit, 2, 2).split('.')[0]), 1),
                                  _createElementVNode("span", _hoisted_38, "." + _toDisplayString(_unref(useCurrencyFormatter)(props.row.deposit, 2, 2).split('.')[1]), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                  _createVNode(_component_q_icon, { name: "mdi-minus" })
                                ]))
                          ]),
                          _: 2
                        }, 1032, ["props", "class"]),
                        _createVNode(_component_q_td, {
                          key: "px",
                          props: props,
                          class: _normalizeClass(props.cols[5 - (__props.application.isQuickQuote ? 1 : 0)]['__thClass'].includes('sorted') ? 'brand-bg-highlight' : '')
                        }, {
                          default: _withCtx(() => [
                            (props.row.px)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                  _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(useCurrencyFormatter)(props.row.px, 2, 2).split('.')[0]), 1),
                                  _createElementVNode("span", _hoisted_42, "." + _toDisplayString(_unref(useCurrencyFormatter)(props.row.px, 2, 2).split('.')[1]), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                  _createVNode(_component_q_icon, { name: "mdi-minus" })
                                ]))
                          ]),
                          _: 2
                        }, 1032, ["props", "class"]),
                        _createVNode(_component_q_td, {
                          key: "totalPayable",
                          props: props,
                          class: _normalizeClass(props.cols[6 - (__props.application.isQuickQuote ? 1 : 0)]['__thClass'].includes('sorted') ? 'brand-bg-highlight' : '')
                        }, {
                          default: _withCtx(() => [
                            (props.row.totalPayable)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                  _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(useCurrencyFormatter)(props.row.totalPayable, 2, 2).split('.')[0]), 1),
                                  _createElementVNode("span", _hoisted_46, "." + _toDisplayString(_unref(useCurrencyFormatter)(props.row.totalPayable, 2, 2).split('.')[1]), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  _createVNode(_component_q_icon, { name: "mdi-minus" })
                                ]))
                          ]),
                          _: 2
                        }, 1032, ["props", "class"]),
                        _createVNode(_component_q_td, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_48, [
                              (__props.application.isQuickQuote)
                                ? (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 0,
                                    class: "brand-button",
                                    label: "Convert",
                                    color: "primary",
                                    outline: "",
                                    onClick: _withModifiers(($event: any) => (convertToProposal(props.row)), ["prevent","stop"])
                                  }, null, 8, ["onClick"]))
                                : (__props.application.state === 0 && props.row.prime)
                                  ? (_openBlock(), _createBlock(_component_q_btn, {
                                      key: 1,
                                      class: "brand-button",
                                      label: "Underwriting",
                                      color: "primary",
                                      outline: "",
                                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showUnderwriting()), ["prevent","stop"]))
                                    }))
                                  : (_openBlock(), _createBlock(_component_q_btn, {
                                      key: 2,
                                      class: "brand-button",
                                      label: "Proceed",
                                      color: "primary",
                                      outline: "",
                                      onClick: _withModifiers(($event: any) => (proceed(props.row, $event)), ["prevent","stop"])
                                    }, null, 8, ["onClick"])),
                              _createVNode(_component_q_btn, {
                                round: "",
                                flat: "",
                                class: "q-ml-sm",
                                size: "sm",
                                icon: "mdi-dots-vertical",
                                onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent","stop"]))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_menu, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_card, {
                                        bordered: "",
                                        style: {"min-width":"180px"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_list, { separator: "" }, {
                                            default: _withCtx(() => [
                                              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                                clickable: "",
                                                class: "flex items-center",
                                                onClick: ($event: any) => (viewQuote(props.row))
                                              }, {
                                                default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                  _createTextVNode("View Quote Details")
                                                ])),
                                                _: 2,
                                                __: [25]
                                              }, 1032, ["onClick"])), [
                                                [_directive_close_popup]
                                              ]),
                                              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                                clickable: "",
                                                class: "flex items-center",
                                                onClick: ($event: any) => (beginSend(props.row.matrix))
                                              }, {
                                                default: _withCtx(() => _cache[26] || (_cache[26] = [
                                                  _createTextVNode("Send to customer...")
                                                ])),
                                                _: 2,
                                                __: [26]
                                              }, 1032, ["onClick"])), [
                                                [_directive_close_popup]
                                              ])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_q_menu, { "context-menu": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_card, { bordered: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_list, { separator: "" }, {
                                  default: _withCtx(() => [
                                    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                      clickable: "",
                                      class: "flex items-center",
                                      onClick: ($event: any) => (viewQuote(props.row))
                                    }, {
                                      default: _withCtx(() => _cache[27] || (_cache[27] = [
                                        _createTextVNode("View Quote Details")
                                      ])),
                                      _: 2,
                                      __: [27]
                                    }, 1032, ["onClick"])), [
                                      [_directive_close_popup]
                                    ]),
                                    _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                      clickable: "",
                                      class: "flex items-center",
                                      onClick: ($event: any) => (beginSend(props.row.matrix))
                                    }, {
                                      default: _withCtx(() => _cache[28] || (_cache[28] = [
                                        _createTextVNode("Send to customer...")
                                      ])),
                                      _: 2,
                                      __: [28]
                                    }, 1032, ["onClick"])), [
                                      [_directive_close_popup]
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["props", "onClick"])
                  ]),
                  "no-data": _withCtx(({ icon, message }) => [
                    (!isProcessing.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createVNode(_component_q_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { side: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_avatar, {
                                    color: "negative",
                                    size: "20px"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_icon, {
                                        name: "mdi-exclamation-thick",
                                        color: "white",
                                        style: {"font-size":"16px","font-weight":"bold"}
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_item_section, { class: "text-subtitle2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(vehicleFailedHP.value ? 'This vehicle does not meet the criteria for HP' : ''), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _createVNode(_component_q_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_section, { side: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_spinner, {
                                    color: "primary",
                                    size: "xs"
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_item_section, { class: "text-subtitle2" }, {
                                default: _withCtx(() => _cache[29] || (_cache[29] = [
                                  _createTextVNode("We are still awaiting a decision")
                                ])),
                                _: 1,
                                __: [29]
                              })
                            ]),
                            _: 1
                          })
                        ]))
                  ]),
                  _: 1
                }, 8, ["rows", "columns", "hide-bottom", "visible-columns", "class", "loading"])
              ]))
            : _createCommentVNode("", true),
          (!__props.application.isQuickQuote && !__props.loading)
            ? (_openBlock(), _createBlock(_component_q_separator, {
                key: 1,
                class: "q-my-md"
              }))
            : _createCommentVNode("", true),
          (!__props.application.isQuickQuote)
            ? (_openBlock(), _createBlock(LenderDecisions, {
                key: 2,
                app: __props.application
              }, null, 8, ["app"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _createVNode(_component_q_btn_group, { spread: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                label: "PCP",
                outline: tab.value!=='pcp',
                color: "primary",
                class: "brand-button",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (tab.value='pcp'))
              }, null, 8, ["outline"]),
              _createVNode(_component_q_btn, {
                label: "HP",
                outline: tab.value!=='hp',
                color: "primary",
                class: _normalizeClass(["brand-button", __props.application.isQuickQuote ? '' : 'btn-group-center-item']),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (tab.value='hp'))
              }, null, 8, ["outline", "class"]),
              (!__props.application.isQuickQuote)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    label: "Decisions",
                    outline: tab.value!=='decisions',
                    color: "primary",
                    "no-caps": "",
                    class: "brand-button",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (tab.value='decisions'))
                  }, null, 8, ["outline"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panels, {
            modelValue: tab.value,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((tab).value = $event)),
            animated: "",
            "transition-prev": "fade",
            "transition-next": "fade"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tab_panel, {
                name: "pcp",
                class: "q-px-none brand-app-bg"
              }, {
                default: _withCtx(() => [
                  (pcpRows.value && pcpRows.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pcpRows.value, (row, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'pcpr'+index,
                            class: "q-mb-md"
                          }, [
                            _createVNode(_component_q_card, { bordered: "" }, {
                              default: _withCtx(() => [
                                _createVNode(QuoteCard, {
                                  row: row,
                                  onView: ($event: any) => (viewQuote(row, true)),
                                  onConvert: ($event: any) => (convertToProposal(row)),
                                  onUnderwriting: _cache[8] || (_cache[8] = ($event: any) => (showUnderwriting())),
                                  onProceed: ($event: any) => (proceed(row, undefined))
                                }, null, 8, ["row", "onView", "onConvert", "onProceed"])
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createBlock(_component_q_card, { key: 1 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_53, _toDisplayString(customerFailedHP.value ? 'Customer has not been approved' : 'PCP'), 1),
                          (__props.loading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                _createVNode(_component_q_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, { side: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_spinner, {
                                          color: "primary",
                                          size: "xs"
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_q_item_section, { class: "text-subtitle2" }, {
                                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                                        _createTextVNode("Getting quotes")
                                      ])),
                                      _: 1,
                                      __: [30]
                                    })
                                  ]),
                                  _: 1
                                })
                              ]))
                            : (!isProcessing.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                  _createVNode(_component_q_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, { side: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_avatar, {
                                            color: "negative",
                                            size: "20px"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_icon, {
                                                name: customerFailedHP.value ? 'mdi-close-thick' : 'mdi-exclamation-thick',
                                                color: "white",
                                                style: {"font-size":"16px","font-weight":"bold"}
                                              }, null, 8, ["name"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item_section, { class: "text-subtitle2" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(customerFailedHP.value ? 'Unfortunately, we’ve not been able to obtain an approval with any of our lenders.' : customerFailedPCP.value ? 'Customer not approved for PCP' : vehicleFailedPCP.value ? 'This vehicle does not meet the criteria for PCP' : ''), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                  _createVNode(_component_q_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, { side: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_spinner, {
                                            color: "primary",
                                            size: "xs"
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item_section, { class: "text-subtitle2" }, {
                                        default: _withCtx(() => _cache[31] || (_cache[31] = [
                                          _createTextVNode("We are still awaiting a decision")
                                        ])),
                                        _: 1,
                                        __: [31]
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]))
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }),
              _createVNode(_component_q_tab_panel, {
                name: "hp",
                class: "q-px-none brand-app-bg"
              }, {
                default: _withCtx(() => [
                  (hpRows.value && hpRows.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hpRows.value, (row, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'hpr'+index,
                            class: "q-mb-md"
                          }, [
                            _createVNode(_component_q_card, {
                              bordered: "",
                              onClick: ($event: any) => (viewQuote(row))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(QuoteCard, {
                                  row: row,
                                  onView: ($event: any) => (viewQuote(row)),
                                  onConvert: ($event: any) => (convertToProposal(row)),
                                  onUnderwriting: _cache[9] || (_cache[9] = ($event: any) => (showUnderwriting())),
                                  onProceed: ($event: any) => (proceed(row, undefined))
                                }, null, 8, ["row", "onView", "onConvert", "onProceed"])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createBlock(_component_q_card, { key: 1 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_58, _toDisplayString(customerFailedHP.value ? 'Customer has not been approved' : 'HP'), 1),
                          (__props.loading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                _createVNode(_component_q_item, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_item_section, { side: "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_spinner, {
                                          color: "primary",
                                          size: "xs"
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_q_item_section, { class: "text-subtitle2" }, {
                                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                                        _createTextVNode("Getting quotes")
                                      ])),
                                      _: 1,
                                      __: [32]
                                    })
                                  ]),
                                  _: 1
                                })
                              ]))
                            : (!isProcessing.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                                  _createVNode(_component_q_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, { side: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_avatar, {
                                            color: "negative",
                                            size: "20px"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_icon, {
                                                name: customerFailedHP.value ? 'mdi-close-thick' : 'mdi-exclamation-thick',
                                                color: "white",
                                                style: {"font-size":"16px","font-weight":"bold"}
                                              }, null, 8, ["name"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item_section, { class: "text-subtitle2" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(customerFailedHP.value ? 'Unfortunately, we’ve not been able to obtain an approval with any of our lenders.' : customerFailedPCP.value ? 'Customer not approved for PCP' : vehicleFailedPCP.value ? 'This vehicle does not meet the criteria for PCP' : ''), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                  _createVNode(_component_q_item, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, { side: "" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_spinner, {
                                            color: "primary",
                                            size: "xs"
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_q_item_section, { class: "text-subtitle2" }, {
                                        default: _withCtx(() => _cache[33] || (_cache[33] = [
                                          _createTextVNode("We are still awaiting a decision")
                                        ])),
                                        _: 1,
                                        __: [33]
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]))
                        ]),
                        _: 1
                      }))
                ]),
                _: 1
              }),
              _createVNode(_component_q_tab_panel, {
                name: "decisions",
                class: "q-pa-none"
              }, {
                default: _withCtx(() => [
                  (!__props.application.isQuickQuote)
                    ? (_openBlock(), _createBlock(LenderDecisions, {
                        key: 0,
                        app: __props.application
                      }, null, 8, ["app"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])),
    _createVNode(_component_DialogContainer, {
      modelValue: viewDetails.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((viewDetails).value = $event)),
      title: "Quote Details",
      maximized: isMobile.value
    }, {
      default: _withCtx(() => [
        _createVNode(StockDetails, {
          vehicle: __props.vehicle,
          pcp: selectedPCP.value ?? null,
          hp: selectedHP.value ?? null,
          filters: filters.value,
          "no-pictures": "",
          selectedProduct: selectedProduct.value,
          ref_key: "stockDetailsRef",
          ref: stockDetailsRef
        }, null, 8, ["vehicle", "pcp", "hp", "filters", "selectedProduct"])
      ]),
      buttons: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _createVNode(_component_q_btn, {
            outline: "",
            class: "brand-button",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (viewDetails.value=false)),
            color: "primary"
          }, {
            default: _withCtx(() => _cache[34] || (_cache[34] = [
              _createElementVNode("span", { class: "" }, "Close", -1)
            ])),
            _: 1,
            __: [34]
          }),
          (__props.application.isQuickQuote)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 0,
                label: "Send to customer",
                class: "brand-button q-ml-sm",
                color: "primary",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (beginSend(selectedQuote.value!)))
              }))
            : _createCommentVNode("", true),
          (__props.application.isQuickQuote)
            ? (_openBlock(), _createBlock(_component_q_btn, {
                key: 1,
                label: "Convert to proposal",
                class: "brand-button q-ml-sm",
                color: "primary",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (convertToProposal(props.row)))
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "maximized"]),
    _createVNode(QuoteSend, {
      modelValue: showSend.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((showSend).value = $event)),
      application: __props.application,
      quote: selectedQuote.value ?? undefined
    }, null, 8, ["modelValue", "application", "quote"])
  ], 64))
}
}

})